import _mixin from '../_mixin'

export default {
  name: 'SVersionCoin',
  cnName: '文案展示类',
  type: 'activity_version',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    showStr: "${" + 'coin' + "}"
  },
  propsDesc: [
    {
      target: 'showStr',
      label: '展示内容的字段(代币:coin)'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
